import React, { useContext, useEffect, useState, forwardRef } from 'react';
import { API, graphqlOperation, Auth } from 'aws-amplify';
import MaterialTable from 'material-table';
import UserContext from '../context/UserContext';
import { listMobileConfigurations } from '../graphql/queries';
import { CheckOutlined, EditOutlined, DeleteOutlineOutlined } from '@material-ui/icons';
import { deleteMob, deleteMobileConfiguration } from '../graphql/mutations';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { Button, Grid, Typography, useTheme } from '@material-ui/core';


export default function MobileConfigrations() {
    const history = useHistory();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const userContext = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        async function getData() {
            setLoading(true);

            setItems((await API.graphql(graphqlOperation(listMobileConfigurations, { tenant: userContext.tenant })))?.data?.listMobileConfigurations?.items ?? []);

            setLoading(false);
        }

        if (userContext.tenant) getData();
    }, [userContext]);

    async function deleteProject(projectId) {
        try {
            const response = await API.del(
                'cdyxdialer',
                '/project/delete',
                {
                    headers: {
                        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
                        'x-api-key': userContext.apiKey
                    },
                    body: {
                        ApplicationId: projectId
                    }
                }
            )

            return response;
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Grid container direction='column' spacing={2}>
            <Grid item>
                <Grid container justifyContent='space-between' alignItems='center' alignContent='center'>
                    <Grid item>
                        <Typography variant='h4'>Applications</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant='contained' color='primary' onClick={() => history.push('/config/mobile-config/new')}>+ Application</Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <MaterialTable
                    isLoading={loading}
                    title=''
                    columns={[
                        { title: 'Project Name', field: 'name' },
                        { title: 'Tenant', field: 'tenant' },
                        { title: 'Description', field: 'description'},
                        { title: 'Date Created', field: 'createdAt', render: rowData => new Date(rowData.createdAt).toLocaleString(), defaultSort: 'desc' }
                    ]}
                    onRowClick={(_, row) => history.push(`/config/mobile-config/${row.id}`)}
                    options={{
                        padding: 'dense',
                        actionsColumnIndex: -1,
                    }}
                    icons={{
                        Delete: forwardRef((props, ref) => <DeleteOutlineOutlined color='primary' {...props} ref={ref} />),
                    }}
                    data={items}
                    editable={{
                        onRowDelete: row => new Promise(async (resolve, reject) => {
                            try {
                                await deleteProject(row.projectId);

                                await API.graphql(graphqlOperation(deleteMobileConfiguration, { input: { id: row.id } }));
                                setItems(items.filter(x => x.id !== row.id));
                                enqueueSnackbar('Project Deleted', { variant: 'success' });
                                resolve();
                            } catch (err) {
                                console.error(err);
                                enqueueSnackbar('Unable to delete Project', { variant: 'error' });
                                reject(err);
                            }
                        })
                    }}
                    actions={[
                        {
                            icon: () => <EditOutlined color='primary' />,
                            onClick: (event, rowData) => {
                                console.log('rowData:', rowData);
                                history.push(`/config/mobile-config/${rowData.id}`);
                            } 
                        }
                    ]}
                />
            </Grid>
        </Grid>
    );
}